import { i18n } from "@lingui/core";
import { useLingui } from "@lingui/react";

import { isLocale, type Locale, localeMap, ordinaryUserLocaleValues, setLocaleServerFn } from "@/utils/locale";

import { Combobox, type SingleComboboxProps } from "../ui/combobox";

type Props = Omit<SingleComboboxProps, "options" | "value" | "onValueChange"> & {
  ordinaryOnly?: boolean;
};

export const getLocaleOptions = (ordinaryOnly = true) => {
  const entries = ordinaryOnly
    ? ordinaryUserLocaleValues.map((value) => [value, localeMap[value]] as const)
    : Object.entries(localeMap);

  return entries.map(([value, label]) => ({
    value: value as Locale,
    label: i18n.t(label),
    keywords: [i18n.t(label)],
  }));
};

export function LocaleCombobox({ ordinaryOnly = true, ...props }: Props) {
  const { i18n } = useLingui();

  const onLocaleChange = async (value: string | null) => {
    if (!value || !isLocale(value)) return;
    await setLocaleServerFn({ data: value });
    window.location.reload();
  };

  return (
    <Combobox
      showClear={false}
      defaultValue={i18n.locale}
      options={getLocaleOptions(ordinaryOnly)}
      onValueChange={onLocaleChange}
      {...props}
    />
  );
}
